// imports
import * as $ from 'jquery';

let bookmarks;

(window as any).unloadBookmarks = unloadBookmarks;

export function initialize(): void {
    $('.js-load-bookmarks').on('click', onShowBookmarks);
};

function unloadBookmarks(): void {
    bookmarks = null;
}

function onShowBookmarks(event: any, params: any): void {

    $("#js-react-bookmarks-expanded .coverages__tabs-container .coverages__tab:first-child").click().focus();

    $(".hero-menu__header-list").animate({ scrollLeft: 0 }, 300);

}
